<template>
  <e-chart
    :header="`${documentTitle}`"
    :options="chartMSNOptions"
    :series="chartMSNSeries"
    chartId="msn"
    :chartRedirectParams="chartRedirectParams"
    :chartLoading="chartLoading"
    :chartError="chartError"
  ></e-chart>
</template>

<script>
import chartsMixin from '../mixins/charts-mixin'

export default {
  mixins: [chartsMixin],
  computed: {
    viewMode: {
      get: function () {
        return this.$store.getters.charts.msn.viewMode
      },
      set: function (newValue) {
        this.$store.commit('charts', { msn: { viewMode: newValue } })
      },
    },
    getCurrentChartOptions() {
      return this.getChartOptions('msn')
    },
  },
  watch: {
    'fields.msn.viewMode': {
      handler: function (v) {
        this.viewMode = v
        this.fetchData()
      },
    },
  },
  methods: {
    buildEndpoint() {
      return this.getEndpoint()({
        query: {
          type: 'msn',
          viewMode: this.viewMode,
        },
      })
    },
    fetchData() {
      this.fetchChartData().then((r) => {
        this.chartMSNSeries = this.transform(r)
      })
    },
  },
  created() {
    this.fetchData()
  },
}
</script>
